import React, { useState, useEffect , useRef} from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import axios from 'axios'; 
import { useReactToPrint } from 'react-to-print';


const Viewinvoice = () => {
    const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    axios
      .get('https://fakestoreapi.com/products?limit=10')
      .then((response) => {
        setProducts(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, [])


  return (
    <div>

<Container>
      <div className='container'>
          <div className='row '>
              <div className='col-lg-12 '>
                  <div className='row ' style={{display:"flex"}} >
                  </div>
                  <div className="row ">
                      <div className="col-lg-6 mt-4  ">
                          
                      </div>
                  </div>
           
                  <div className="row mt-4">
                  <div className="col-lg-12">
                      <div className="card" ref={componentRef}>
                      <div className="card-header"  style={{backgroundColor:"rgb(0,156,216)",color:'white'}}>
                          <h4> View Invoice </h4>
                      </div>
                      <div className="card-body">
                          <div className="">
                          <ButtonGroup className="mb-2">
                                 {/* <Button>Copy </Button>
                                  <Button>Excel</Button> */}
                                   <Button  onClick={handlePrint} >Download PDF</Button>
                                   {/* <Button>Column visibility</Button> */}
                                  </ButtonGroup>
                          </div>
                          <form>
                          <div className="card-body">
                              <div className='table-responsive'>
                              <table className="table table-bordered">
        
                              <thead>
                                  <tr>
                                  <th scope="col">Sl No</th>
                                  <th scope="col">Customer Name</th>
                                  <th scope="col">Invoice No</th>
                                  <th scope="col">Invoice Date</th>
                                  <th scope="col">Email</th>
                                  <th scope="col">Phone</th>
                                  <th scope="col">City</th>
                                  <th scope="col">State</th>
                                  <th scope="col">Pin Code</th>
                                  <th scope="col">Name of the product</th>
                                  <th scope="col">NO of Product</th>
                                  <th scope="col">Sub Total</th>
                                  <th scope="col">Tax</th>
                                  <th scope="col">Total Amount</th>
                                  <th scope="col">Paid Amount</th>
                                  <th scope="col">Pending Amount</th>
                                  <th scope="col">Remainder </th>
                                  <th scope="col">Action</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  {loading ? (
                                  <tr>
                                    <td colSpan="4">Loading...</td>
                                  </tr>
                                ) : (
                                  products.map((product) => (
                                    <tr key={product.id}>
                                      <td>{product.id}</td>
                                      <td>{product.title}</td>
                                      <td>{product.price}</td>
                                      <td>{product.description}</td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                  <td> <Button variant="primary">Update</Button>{' '}</td>
                                  <td><Button variant="primary">Update</Button>{' '}
                                  </td>
                                  </tr>
                                  ))
                                )} 
                              </tbody>
                              </table>
                              <nav aria-label="...">
                                 <ul class="pagination">
                                   <li class="page-item disabled">
                                      <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
                                        </li>
                                       <li class="page-item"><a class="page-link" href="#">1</a></li>
                                        <li class="page-item active" aria-current="page">
                                         <a class="page-link" href="#">2</a>
                                         </li>
                                       <li class="page-item"><a class="page-link" href="#">3</a></li>
                                       <li class="page-item">
                                    <a class="page-link" href="#">Next</a>
                                  </li>
                                 </ul>
                                </nav>
                              </div>
                          </div>
                          </form>
                      </div>
                      </div>
                  </div>
                  </div>
              </div>
          </div>
      </div>
  </Container>
    </div>
  )
}

export default Viewinvoice;

